import { defineComponent as h, createBlock as u, openBlock as d, resolveDynamicComponent as b, mergeProps as g, unref as t, withCtx as B, createElementBlock as C, createCommentVNode as v, renderSlot as P, createElementVNode as L } from "vue";
import { useOUIAProps as O } from "./packages/core/dist/helpers/ouia.js";
import o from "./node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Table/table.js";
import l from "./node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Table/table-scrollable.js";
import { classesFromBreakpointProps as S } from "./packages/core/dist/breakpoints.js";
import { isDefined as n } from "./node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const w = { key: 0 }, R = ["checked"], A = /* @__PURE__ */ h({
  name: "PfTd",
  __name: "Td",
  props: {
    component: { default: "td" },
    textCenter: { type: Boolean },
    modifier: {},
    width: {},
    dataLabel: {},
    selected: { type: Boolean, default: void 0 },
    draggable: { type: [String, Boolean] },
    noPadding: { type: Boolean },
    actionCell: { type: Boolean },
    sticky: { type: Boolean },
    rightBorder: { type: Boolean },
    leftBorder: { type: Boolean },
    stickyMinWidth: {},
    stickyLeftOffset: {},
    stickyRightOffset: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["select", "update:selected"],
  setup(f, { emit: c }) {
    const i = f, s = c, p = O({ id: i.ouiaId, safe: i.ouiaSafe }), m = S(i, ["visibility"], o, { short: !0 });
    function y(e) {
      s("select", e, e.target.checked), s("update:selected", e.target.checked);
    }
    return (e, a) => {
      var r;
      return d(), u(b(e.component), g(t(p), {
        role: "cell",
        class: [
          t(o).tableTd,
          e.width && [t(o).modifiers[`width_${e.width}`]],
          e.modifier && t(o).modifiers[e.modifier],
          t(m),
          {
            [t(o).tableAction]: e.actionCell,
            [t(o).tableDraggable]: e.draggable,
            [t(o).modifiers.center]: e.textCenter,
            [t(o).modifiers.noPadding]: e.noPadding,
            [t(o).tableCheck]: t(n)(e.selected),
            [t(l).tableStickyCell]: e.sticky,
            [t(l).modifiers.borderRight]: e.rightBorder,
            [t(l).modifiers.borderLeft]: e.leftBorder
          }
        ],
        style: e.sticky ? {
          "--pf-v6-c-table__sticky-cell--MinWidth": e.stickyMinWidth ? e.stickyMinWidth : void 0,
          "--pf-v6-c-table__sticky-cell--Left": e.stickyLeftOffset ? e.stickyLeftOffset : 0,
          "--pf-v6-c-table__sticky-cell--Right": e.stickyRightOffset ? e.stickyRightOffset : 0
        } : void 0,
        "data-label": ((r = e.$attrs.class) == null ? void 0 : r.includes("pf-v6-c-table__tree-view-title-cell")) || e.dataLabel
      }), {
        default: B(() => [
          t(n)(e.selected) ? (d(), C("label", w, [
            L("input", {
              checked: e.selected,
              type: "checkbox",
              onChange: a[0] || (a[0] = (k) => y(k))
            }, null, 40, R)
          ])) : v("", !0),
          P(e.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "style", "data-label"]);
    };
  }
});
export {
  A as default
};
